import React from "react";
import Login from "./loginWrapper/Login";

export default function LoginWrapper({todos, login, requestLogin, history}){
    let props = {
        todos: todos,
        login: login,
        requestLogin: requestLogin,
        history: history
    };

    return (
        <Login props={props}  />
    );
}


// WEBPACK FOOTER //
// ./src/components/general/LoginWrapper.jsx